import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { X, Copy, Check } from 'lucide-react';
import axiosInstance from '../api/axios';

/**
 * Schmaler, dezenter Ankündigungs-Banner ganz oben über der Navbar.
 *
 * - Brand-Farben (Cream-Hintergrund mit dunkelbraunem Text + Akzent)
 * - Dismissible (Schließen-X) und in localStorage gemerkt, damit der Banner
 *   nicht bei jedem Seitenaufruf neu erscheint, aber wiederkommt, sobald der
 *   Banner-Schlüssel ("HOMEYOURSOUL_LAUNCH_BANNER_V1") geändert wird.
 * - Copy-to-Clipboard für den Rabatt-Code.
 */
const STORAGE_KEY = 'hys-launch-banner-v4';

const AnnouncementBanner = () => {
  const [visible, setVisible] = useState(false);
  const [copied, setCopied] = useState(false);
  const [promo, setPromo] = useState(null);

  useEffect(() => {
    const dismissed = localStorage.getItem(STORAGE_KEY) === '1';
    setVisible(!dismissed);
    axiosInstance.get('/settings/coupon-promo').then((r) => setPromo(r.data)).catch(() => {});
  }, []);

  if (!visible || !promo || !promo.banner_enabled || !promo.banner_code) return null;
  const code = promo.banner_code;

  const handleClose = () => {
    localStorage.setItem(STORAGE_KEY, '1');
    setVisible(false);
  };

  const handleCopy = (e) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      navigator.clipboard.writeText(code);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch {
      /* clipboard not available — silent fallback */
    }
  };

  return (
    <div
      className="relative w-full"
      style={{ backgroundColor: '#5D4E3C' }}
      data-testid="announcement-banner"
    >
      <div className="max-w-7xl mx-auto px-3 py-1 flex items-center justify-center gap-2 text-white text-[11px] sm:text-xs">
        <span
          className="flex items-center gap-1.5 flex-wrap justify-center"
          style={{ fontFamily: 'Georgia, serif' }}
        >
          <span className="opacity-90" data-testid="banner-text">🎁&nbsp;{promo.banner_text}</span>
          <span className="opacity-70 hidden sm:inline">mit Code</span>
          <button
            type="button"
            onClick={handleCopy}
            className="inline-flex items-center gap-1 px-1.5 py-[1px] font-mono tracking-[1.5px] text-[10px] sm:text-[11px] hover:opacity-90 transition-opacity"
            style={{ backgroundColor: '#C4A084', color: '#FFFFFF' }}
            data-testid="banner-copy-code"
            aria-label="Code kopieren"
          >
            {code}
            {copied ? <Check className="h-2.5 w-2.5" /> : <Copy className="h-2.5 w-2.5" />}
          </button>
          <Link to="/products" className="opacity-80 underline-offset-2 hover:underline hidden sm:inline">
            zum Shop →
          </Link>
        </span>

        <button
          type="button"
          onClick={handleClose}
          className="absolute right-1.5 top-1/2 -translate-y-1/2 p-0.5 text-white/70 hover:text-white"
          data-testid="banner-close"
          aria-label="Banner schließen"
        >
          <X className="h-3.5 w-3.5" />
        </button>
      </div>
    </div>
  );
};

export default AnnouncementBanner;
